// FEED panel — single-row buy with a live countdown when the buff is active.
// Re-buying mid-buff extends the timer.

import { Events, on, emit } from './eventBus.js'
import { FeedConfig } from '../config/balance.js'
import { getWealth } from '../game/seasonManager.js'
import { isActive, remainingMs, feedCost } from '../game/feedManager.js'
import { makeModalToggleable } from './railPanel.js'
import { formatCoins } from './format.js'
import { appendBuyCoinsLink } from './buyCoinsLink.js'

export function mountFeedPanel({ root, toggleBtn }) {
  root.innerHTML = `
    <div class="hud__build-header">
      <span class="hud__build-title">FEED</span>
      <span class="hud__build-tiles" data-status>—</span>
    </div>
    <div class="hud__feed-row">
      <div class="hud__build-info">
        <div class="hud__build-name">Feed the Kingdom</div>
        <div class="hud__build-desc">+${FeedConfig.goonRateBonus * 100}% goon speed for ${FeedConfig.durationMs / 1000}s · ${FeedConfig.costPerCitizen}m per citizen</div>
      </div>
      <button class="hud__build-buy" data-buy>
        <span class="lbl" data-buy-lbl>FEED</span>
        <span class="price" data-buy-price>${formatCoins(feedCost())}</span>
      </button>
    </div>
  `

  const buyEl = root.querySelector('[data-buy]')
  const lblEl = root.querySelector('[data-buy-lbl]')
  const priceEl = root.querySelector('[data-buy-price]')
  const statusEl = root.querySelector('[data-status]')

  buyEl.addEventListener('click', () => emit(Events.FeedBuyRequested))

  const refresh = () => {
    const active = isActive()
    const remaining = Math.ceil(remainingMs() / 1000)
    const cost = feedCost()
    statusEl.textContent = active ? `ACTIVE — ${remaining}s` : 'INACTIVE'
    statusEl.classList.toggle('active', active)
    lblEl.textContent = active ? 'EXTEND' : 'FEED'
    priceEl.textContent = formatCoins(cost)
    buyEl.disabled = getWealth() < cost
  }

  on(Events.WealthChange, refresh)
  on(Events.FeedActivated, refresh)
  on(Events.GoonOwnedChange, refresh) // cost scales with citizen count
  setInterval(refresh, 250)
  refresh()

  appendBuyCoinsLink(root) // quiet link to the Shop, at the foot of the pop-up
  makeModalToggleable(root, toggleBtn)
}
